import { useState, useMemo } from "react";
import SectionLabel from "@/components/SectionLabel";

// Source: provided June 2026 schedule
export const calendar = [
  {
    date: "June 1, 2026",
    day: "Monday",
    note: "Diocesan Clergy Midyear Gathering (June 1–3)",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:30 AM", e: "Holy Mass", v: "BLGU Mabuhay" },
    ],
  },
  {
    date: "June 2, 2026",
    day: "Tuesday",
    events: [{ t: "—", e: "No Schedule", v: "Diocesan Clergy Midyear Gathering" }],
  },
  {
    date: "June 3, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 4, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Our Lady of Fatima, Klinan 5 (Extension)" },
      { t: "7:00 PM", e: "Holy Mass", v: "Hangar Gymnasium (Phase 3)" },
    ],
  },
  {
    date: "June 5, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK San Lorenzo Ruiz (Olano)" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK San Isidro Labrador (Pearly Shell)" },
    ],
  },
  {
    date: "June 6, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:30 AM", e: "Regular Wedding", v: "Parish Church" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "3:00 PM", e: "Holy Mass", v: "GKK Christ the King (Bagong Pag Asa)" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 7, 2026",
    day: "Sunday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK San Roque (Yamville)" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "1:00 PM", e: "General Assembly", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 8, 2026",
    day: "Monday",
    events: [{ t: "6:00 AM", e: "Holy Mass", v: "Parish Church" }],
  },
  {
    date: "June 9, 2026",
    day: "Tuesday",
    events: [{ t: "—", e: "No Office", v: "" }],
  },
  {
    date: "June 10, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 11, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
    ],
  },
  {
    date: "June 12, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "Parish Church" },
    ],
  },
  {
    date: "June 13, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 14, 2026",
    day: "Sunday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 15, 2026",
    day: "Monday",
    events: [{ t: "6:00 AM", e: "Holy Mass", v: "Parish Church" }],
  },
  {
    date: "June 16, 2026",
    day: "Tuesday",
    events: [
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Our Lady of Immaculate Conception (Dacville Phase 3)" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Sr. Sto. Niño (Dacera Village)" },
    ],
  },
  {
    date: "June 17, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Our Lady of Miraculous Medal (Philgo)" },
    ],
  },
  {
    date: "June 18, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Sr. Sto. Niño (Golingan)" },
      { t: "7:00 PM", e: "Holy Mass", v: "Brixton Subdivision" },
    ],
  },
  {
    date: "June 19, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK San Vicente Ferrer (Roseville)" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Our Lady of Miraculous Medal (Uson B)" },
    ],
  },
  {
    date: "June 20, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:30 AM", e: "Regular Wedding", v: "Parish Church" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "3:00 PM", e: "Holy Mass", v: "GKK St. Joseph the Worker (NAHA Village)" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 21, 2026",
    day: "Sunday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Our Lady of the Holy Rosary (Prk. Upper Matibay)" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "10:30 AM", e: "Holy Mass", v: "GKK Our Lady of Assumption (Promised Land 1)" },
      { t: "3:00 PM", e: "Holy Mass", v: "GKK Sr. San Roque (Uson A, Purok 12)" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 22, 2026",
    day: "Monday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK San Isidro Labrador (Prk 20)" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Our Lady of Immaculate Conception (Purok 10 Parreñas Village)" },
    ],
  },
  {
    date: "June 23, 2026",
    day: "Tuesday",
    events: [
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Sagrada Familia (Uson C)" },
      { t: "7:00 PM", e: "Holy Mass", v: "Riverview Subdivision" },
    ],
  },
  {
    date: "June 24, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "10:00 AM", e: "House Blessing", v: "Purok 1" },
      { t: "1:00 PM", e: "Funeral Mass", v: "GKK Our Lady of Assumption, Promised Land 1, Mabuhay" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Our Lady of Fatima (Klinan 5)" },
    ],
  },
  {
    date: "June 25, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
      { t: "5:00 PM", e: "Novena Mass", v: "Saints Peter and Paul Parish, Lagao, General Santos City" },
    ],
  },
  {
    date: "June 26, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Dwelling Subdivision" },
      { t: "7:00 PM", e: "Holy Mass", v: "Rebecca Homes Phase A Subdivision" },
    ],
  },
  {
    date: "June 27, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Fiesta Mass", v: "GKK Our Mother of Perpetual Help (Dacville Phase 2)" },
      { t: "10:00 AM", e: "Fiesta Mass", v: "GKK Our Mother of Perpetual Help (Promised Land 2)" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 28, 2026",
    day: "Sunday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Sr. San Roque (Purok 24 Display Village)" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "10:30 AM", e: "Holy Mass", v: "GKK San Isidro Labrador (Cuyos)" },
      { t: "3:00 PM", e: "Holy Mass", v: "GKK St. Margaret of Scotland (Purok 4 Raña Village)" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "June 29, 2026",
    day: "Monday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "1:30 PM", e: "Class", v: "NDMU" },
    ],
  },
  {
    date: "June 30, 2026",
    day: "Tuesday",
    events: [{ t: "—", e: "No scheduled activity posted", v: "" }],
  },

  // ---------- July 2026 ----------
  {
    date: "July 1, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "July 2, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Our Lady of Fatima, Klinan 5 (Extension)" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Sto. Niño, Uson Phase 5" },
    ],
  },
  {
    date: "July 3, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK San Lorenzo Ruiz, Olano" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK San Isidro Labrador, Pearly Shell" },
    ],
  },
  {
    date: "July 4, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:30 AM", e: "Regular Wedding", v: "Parish Church" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK San Roque, Yamville 1" },
    ],
  },
  {
    date: "July 5, 2026",
    day: "Sunday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Christ the King, Bagong Pag Asa" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "10:30 AM", e: "Holy Mass", v: "GKK St. Joseph the Worker, Windsor Heights" },
      { t: "1:00 PM", e: "General Assembly", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "July 6, 2026",
    day: "Monday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:30 AM", e: "Holy Mass", v: "BLGU Mabuhay" },
      { t: "1:30 PM", e: "Class", v: "NDMU" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Sr. Sto. Niño, Dacera Village" },
    ],
  },
  {
    date: "July 7, 2026",
    day: "Tuesday",
    events: [
      { t: "5:30 PM", e: "Holy Mass", v: "GKK San Jose, Bactol Village" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK San Roque, Intake" },
    ],
  },
  {
    date: "July 8, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Our Lady of Fatima, Klinan 5" },
    ],
  },
  {
    date: "July 9, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Our Lady of Manaoag, Dacville Phase 1" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK St. Therese of the Child Jesus, Purok Nopol" },
    ],
  },
  {
    date: "July 10, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK San Isidro Labrador, Mirabueno" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK San Vicente Ferrer, Luwalhati" },
    ],
  },
  {
    date: "July 11, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "July 12, 2026",
    day: "Sunday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK San Roque, Uson Phase 4" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "10:30 AM", e: "Holy Mass", v: "GKK Santo Niño, Habitat A" },
      { t: "3:00 PM", e: "Holy Mass", v: "GKK Our Lady of Immaculate Conception, Purok Panaghiusa" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "July 13, 2026",
    day: "Monday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "Hangar Gymnasium (Phase 3)" },
    ],
  },
  {
    date: "July 14, 2026",
    day: "Tuesday",
    events: [
      { t: "6:00 PM", e: "Evening Praise", v: "Meeting of Priests assigned in Metro Dadiangas Area" },
    ],
  },
  {
    date: "July 15, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "July 16, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Santo Niño, Golingan" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK San Vicente Ferrer, Orillano Homes" },
    ],
  },
  {
    date: "July 17, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "Parish Church" },
      { t: "9:00 AM – 12:00 PM", e: "Appointment", v: "General Santos City" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Sr. San Roque, Purok Display Village" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Our Lady of Miraculous Medal, Uson B" },
    ],
  },
  {
    date: "July 18, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:30 AM", e: "Regular Wedding", v: "Parish Church" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "3:00 PM", e: "Solo Wedding", v: "GKK Santo Niño Chapel, Habitat Phase A, Mabuhay, GSC" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Our Lady of Assumption, Promised Land 1" },
    ],
  },
  {
    date: "July 19, 2026",
    day: "Sunday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Our Lady of Immaculate Conception, Dacville Phase 3" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "10:30 AM", e: "Holy Mass", v: "GKK Santo Niño, Habitat Phase A, Mabuhay, GSC" },
      { t: "3:00 PM", e: "Holy Mass", v: "GKK Sr. San Roque, Uson A" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "July 20, 2026",
    day: "Monday",
    note: "Clergy Retreat, Iloilo (July 20–25)",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "—", e: "Clergy Retreat", v: "Iloilo" },
    ],
  },
  {
    date: "July 21, 2026",
    day: "Tuesday",
    events: [{ t: "—", e: "Clergy Retreat", v: "Iloilo" }],
  },
  {
    date: "July 22, 2026",
    day: "Wednesday",
    events: [{ t: "—", e: "Clergy Retreat", v: "Iloilo" }],
  },
  {
    date: "July 23, 2026",
    day: "Thursday",
    events: [{ t: "—", e: "Clergy Retreat", v: "Iloilo" }],
  },
  {
    date: "July 24, 2026",
    day: "Friday",
    events: [{ t: "—", e: "Clergy Retreat", v: "Iloilo" }],
  },
  {
    date: "July 25, 2026",
    day: "Saturday",
    events: [
      { t: "—", e: "Clergy Retreat", v: "Iloilo" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK San Isidro Labrador, Cuyos, Mabuhay, GSC" },
    ],
  },
  {
    date: "July 26, 2026",
    day: "Sunday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK San Vicente Ferrer, Roseville" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "10:30 AM", e: "Holy Mass", v: "GKK Santo Niño, Habitat Phase A, Mabuhay, GSC" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "July 27, 2026",
    day: "Monday",
    events: [{ t: "6:00 AM", e: "Holy Mass", v: "Parish Church" }],
  },
  {
    date: "July 28, 2026",
    day: "Tuesday",
    events: [{ t: "—", e: "No scheduled activity posted", v: "" }],
  },
  {
    date: "July 29, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "July 30, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Our Lady of Miraculous Medal, Philgo" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Our Lady, Mother of Perpetual Help, Promised Land 2 (Extension)" },
    ],
  },
  {
    date: "July 31, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Our Lady, Mother of Perpetual Help, Dacville Phase 2" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Our Lady, Mother of Perpetual Help, Promised Land 2" },
    ],
  },

  // ---------- August 2026 ----------
  {
    date: "August 19, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:30 AM", e: "Class", v: "NDMU" },
      { t: "1:30 PM", e: "Class", v: "NDMU" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "August 20, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:00 AM", e: "Funeral Mass", v: "GKK San Roque, Uson 4 (+Hernani)" },
      { t: "11:00 AM", e: "Appointment", v: "Rectory" },
      { t: "4:00 PM", e: "Wake Mass", v: "GKK Our Lady of Assumption, Promised Land 1 (+Castanares)" },
      { t: "5:30 PM", e: "Holy Mass", v: "Klinan 5 – Community 2" },
      { t: "7:00 PM", e: "Holy Mass", v: "Klinan 5 – Community 3" },
    ],
  },
  {
    date: "August 21, 2026",
    day: "Friday",
    events: [
      { t: "7:00 AM", e: "Holy Mass", v: "30th Foundation Anniversary, Engracia Valdomar National High School" },
      { t: "9:00 AM", e: "Confession", v: "First Communicants" },
      { t: "5:30 PM", e: "Holy Mass", v: "Southmin, Yamville" },
      { t: "7:00 PM", e: "Holy Mass", v: "Purok Bato, Yamville" },
    ],
  },
  {
    date: "August 22, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Fiesta Mass", v: "GKK San Roque, Intake" },
      { t: "10:00 AM", e: "Fiesta Mass", v: "GKK San Roque, Yamville 1" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Fiesta Mass", v: "GKK San Roque, Purok Display" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "August 23, 2026",
    day: "Sunday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Our Lady, Mother of Perpetual Help, Dacville 2" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "10:30 AM", e: "Holy Mass", v: "GKK Santo Niño, Habitat A" },
      { t: "3:00 PM", e: "Holy Mass", v: "Primeland Subdivision" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "August 24, 2026",
    day: "Monday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "1:30 PM", e: "Class", v: "NDMU" },
    ],
  },
  {
    date: "August 25, 2026",
    day: "Tuesday",
    events: [
      { t: "1:30 PM", e: "Class", v: "NDMU" },
      { t: "5:30 PM", e: "Holy Mass", v: "Philgo Community 2" },
      { t: "7:00 PM", e: "Holy Mass", v: "Philgo Community 3" },
    ],
  },
  {
    date: "August 26, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:30 AM", e: "Class", v: "NDMU" },
      { t: "1:30 PM", e: "Class", v: "NDMU" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "Cuyos Community 2" },
    ],
  },
  {
    date: "August 27, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
      { t: "5:30 PM", e: "Holy Mass", v: "Rebecca A Homes" },
      { t: "7:00 PM", e: "Holy Mass", v: "Viviene Subdivision" },
    ],
  },
  {
    date: "August 28, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK Our Lady, Mother of Perpetual Help, Promised Land 2 Extension" },
      { t: "7:00 PM", e: "Holy Mass", v: "Windsor Homes" },
    ],
  },
  {
    date: "August 29, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Fiesta Mass", v: "GKK San Roque, Uson 4" },
      { t: "10:00 AM", e: "Fiesta Mass", v: "GKK San Roque, Uson A" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "August 30, 2026",
    day: "Sunday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK St. Joseph the Worker, NAHA Village" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "10:30 AM", e: "Holy Mass", v: "GKK Santo Niño, Habitat A" },
      { t: "3:00 PM", e: "Holy Mass", v: "GKK San Gabriel, Tagumpay" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "August 31, 2026",
    day: "Monday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
    ],
  },

  // ---------- September 2026 ----------
  {
    date: "September 1, 2026",
    day: "Tuesday",
    note: "World Day of Prayer for the Care of Creation · Green",
    events: [
      { t: "—", e: "World Day of Prayer for the Care of Creation", v: "" },
    ],
  },
  {
    date: "September 2, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church (Fr. Jefil)" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church (Fr. Jefil)" },
    ],
  },
  {
    date: "September 3, 2026",
    day: "Thursday",
    note: "St. Gregory the Great, Pope and Doctor of the Church · Memorial · White",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
    ],
  },
  {
    date: "September 4, 2026",
    day: "Friday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Our Lady of Miraculous Medal, Philgo" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:15 AM", e: "Holy Mass", v: "Notre Dame of Saint Therese" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK St. Therese, Nopol" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Christ the King, Bagong Pag-Asa" },
    ],
  },
  {
    date: "September 5, 2026",
    day: "Saturday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Santo Niño, Arizala" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:00 AM", e: "Fiesta Mass", v: "GKK St. Teresa of Calcutta, Klinan 5" },
      { t: "11:00 AM", e: "Wake Mass", v: "GKK Our Lady of Immaculate Conception, Balapurco" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "Riverview" },
    ],
  },
  {
    date: "September 6, 2026",
    day: "Sunday",
    note: "23rd Sunday in Ordinary Time · Green",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK San Isidro Labrador, Malayang Nayon" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church · Cebuano" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church · English (Fr. Angel)" },
      { t: "8:00 AM", e: "Holy Mass", v: "GKK Santo Niño, Habitat A · English (Fr. Ariel)" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "1:00 PM", e: "General Assembly", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church · English" },
    ],
  },
  {
    date: "September 7, 2026",
    day: "Monday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:00 AM", e: "Holy Mass", v: "BLGU Mabuhay" },
    ],
  },
  {
    date: "September 8, 2026",
    day: "Tuesday",
    note: "The Nativity of the Blessed Virgin Mary · Feast · White",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "Notre Dame of Saint Therese" },
      { t: "5:00 PM", e: "Holy Mass", v: "Santo Niño Parish, Bula" },
    ],
  },
  {
    date: "September 9, 2026",
    day: "Wednesday",
    note: "St. Peter Claver, Priest · Memorial · White",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK San Roque, Yamville 1" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK Santo Niño, Dacera" },
    ],
  },
  {
    date: "September 10, 2026",
    day: "Thursday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Sagrada Familia, Uson C" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Funeral Mass", v: "GKK Santo Niño, Habitat A" },
      { t: "5:30 PM", e: "Holy Mass", v: "Acacia, Intake" },
      { t: "7:00 PM", e: "Holy Mass", v: "Bulawan, Intake" },
    ],
  },
  {
    date: "September 11, 2026",
    day: "Friday",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Our Lady of Immaculate Conception, Panaghiusa" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK San Isidro Labrador, Malayang Nayon" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK San Juan Maria Vianney, Dwelling Homes" },
    ],
  },
  {
    date: "September 12, 2026",
    day: "Saturday",
    note: "The Most Holy Name of Mary · Memorial · White",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Our Lady of Fatima, Klinan 5" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "8:00 AM", e: "Holy Mass", v: "GKK San Isidro Labrador, Purok 20" },
      { t: "10:00 AM", e: "Holy Mass", v: "GKK Santo Niño, Purok 7" },
      { t: "5:30 PM", e: "Holy Mass", v: "GKK San Pedro Calungsod, Southmin" },
      { t: "7:00 PM", e: "Holy Mass", v: "GKK San Vicente Ferrer, Roseville" },
    ],
  },
  {
    date: "September 13, 2026",
    day: "Sunday",
    note: "24th Sunday in Ordinary Time · Green · National Catechetical Day",
    events: [
      { t: "4:30 AM", e: "Holy Mass", v: "GKK Our Lady of the Rosary, Upper Matibay" },
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church · Cebuano" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church · English (Fr. Ariel)" },
      { t: "8:00 AM", e: "Holy Mass", v: "GKK Santo Niño, Habitat A · Cebuano (Fr. Angel)" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church · English" },
    ],
  },
  {
    date: "October 22, 2026",
    day: "Thursday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "2:00 PM", e: "Interview", v: "Parish Office" },
      { t: "7:00 PM", e: "Confession", v: "Holy Cross Spiritual Center, Calumpang" },
    ],
  },
  {
    date: "October 23, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Confession", v: "" },
      { t: "6:00 PM", e: "Pre-fiesta Seminar", v: "GKK Saint John Paul II, Riverview Subdivision" },
      { t: "7:00 PM", e: "Wake Mass", v: "GKK Our Lady of Fatima (+Almonicar)" },
    ],
  },
  {
    date: "October 24, 2026",
    day: "Saturday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:30 AM", e: "Funeral Mass", v: "GKK Santo Niño, Habitat A" },
      { t: "9:00 AM", e: "Store Blessing", v: "GKK Santo Niño, Habitat A" },
      { t: "10:00 AM", e: "Fiesta Mass", v: "GKK San Pedro Calungsod, Southmin Subdivision" },
      { t: "1:00 PM", e: "Funeral Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "October 25, 2026",
    day: "Sunday",
    note: "Distribution of Holy Water Containers",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "6:00 AM", e: "Holy Mass", v: "GKK San Isidro Labrador, Mirabueno" },
      { t: "8:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "9:30 AM", e: "Baptism", v: "Parish Church" },
      { t: "1:00 PM", e: "Zone 2 Panaw-Duaw", v: "GKK Santo Niño, Habitat A" },
      { t: "1:00 PM", e: "Misa de Gallo Sharers' Final Formation and Reflection Workshop", v: "" },
      { t: "3:00 PM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:00 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "October 26, 2026",
    day: "Monday",
    events: [{ t: "6:00 AM", e: "Holy Mass", v: "Parish Church" }],
  },
  {
    date: "October 27, 2026",
    day: "Tuesday",
    events: [{ t: "—", e: "No Schedule", v: "" }],
  },
  {
    date: "October 28, 2026",
    day: "Wednesday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "5:30 PM", e: "Holy Mass", v: "Parish Church" },
    ],
  },
  {
    date: "October 29, 2026",
    day: "Thursday",
    events: [{ t: "6:00 AM", e: "Holy Mass", v: "Parish Church" }],
  },
  {
    date: "October 30, 2026",
    day: "Friday",
    events: [
      { t: "6:00 AM", e: "Holy Mass", v: "Parish Church" },
      { t: "7:00 AM", e: "Fiesta Mass", v: "GKK Saint John Paul II, Riverview Subdivision" },
    ],
  },
];

const todayIso = () => new Date().toISOString().slice(0, 10);

// Parse "June 24, 2026" → Date
function parseEntryDate(s) {
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

// Find Sunday (start) and Saturday (end) of week containing `date`
function weekRange(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay(); // 0 = Sun
  const sun = new Date(d);
  sun.setDate(d.getDate() - day);
  const sat = new Date(sun);
  sat.setDate(sun.getDate() + 6);
  return [sun, sat];
}

function fmtRange(start, end) {
  const s = start.toLocaleDateString("en-PH", { month: "short", day: "numeric" });
  const e = end.toLocaleDateString("en-PH", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return `${s} — ${e}`;
}

export default function ParishCalendar() {
  // Anchor date — the "today" for current-week computation
  const [anchor, setAnchor] = useState(() => new Date());

  // Map each entry to a Date once
  const entriesWithDate = useMemo(
    () =>
      calendar
        .map((d) => ({ ...d, _date: parseEntryDate(d.date) }))
        .filter((d) => d._date),
    []
  );

  const [weekStart, weekEnd] = useMemo(() => weekRange(anchor), [anchor]);
  const inWeek = useMemo(
    () =>
      entriesWithDate.filter(
        (d) => d._date >= weekStart && d._date <= new Date(weekEnd.getTime() + 86399999)
      ),
    [entriesWithDate, weekStart, weekEnd]
  );

  const shift = (days) => {
    const next = new Date(anchor);
    next.setDate(anchor.getDate() + days);
    setAnchor(next);
  };

  const isCurrentWeek = (() => {
    const [a, b] = weekRange(new Date());
    return a.getTime() === weekStart.getTime() && b.getTime() === weekEnd.getTime();
  })();

  return (
    <section id="calendar" className="py-24 md:py-36 bg-parchment-200 grain">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <SectionLabel
          kicker={isCurrentWeek ? "This Week · Parish Calendar" : "Parish Calendar"}
          title="Calendar of Activities"
          intro="A week of Masses, GKK celebrations, weddings, baptisms, and pastoral work across the parish."
        />

        {/* Week navigation */}
        <div className="mt-12 flex items-center justify-between gap-4 flex-wrap">
          <button
            type="button"
            onClick={() => shift(-7)}
            data-testid="cal-prev-week"
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-cocoa-800 hover:text-terracotta font-sans"
          >
            ← Previous week
          </button>

          <div className="text-center">
            <div className="text-[10px] uppercase tracking-[0.3em] text-sage-dark font-sans">
              {isCurrentWeek ? "This Week" : "Week of"}
            </div>
            <div className="font-serif text-2xl md:text-3xl text-cocoa-900 mt-1">
              {fmtRange(weekStart, weekEnd)}
            </div>
          </div>

          <div className="flex items-center gap-4">
            {!isCurrentWeek && (
              <button
                type="button"
                onClick={() => setAnchor(new Date())}
                data-testid="cal-this-week"
                className="text-[11px] uppercase tracking-[0.28em] text-terracotta hover:text-cocoa-900 font-sans"
              >
                ✦ This week
              </button>
            )}
            <button
              type="button"
              onClick={() => shift(7)}
              data-testid="cal-next-week"
              className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-cocoa-800 hover:text-terracotta font-sans"
            >
              Next week →
            </button>
          </div>
        </div>

        <div className="mt-10 space-y-4">
          {inWeek.length === 0 ? (
            <div className="border border-dashed border-parchment-400 p-16 text-center text-cocoa-700 font-sans">
              ✦ No scheduled activities posted for this week.
              <div className="text-[11px] uppercase tracking-[0.22em] text-sage-dark mt-2">
                Please check with the parish office.
              </div>
            </div>
          ) : (
            inWeek.map((day) => (
              <article
                key={day.date}
                className="bg-parchment-50 border border-parchment-400 grid md:grid-cols-12"
              >
                <div className="md:col-span-3 bg-cocoa-900 text-parchment-100 p-6 md:p-7">
                  <div className="text-[10px] uppercase tracking-[0.28em] text-gold font-sans">
                    {day.day}
                  </div>
                  <div className="font-serif text-2xl mt-2 leading-tight">{day.date}</div>
                  {day.note && (
                    <div className="mt-4 text-[11px] uppercase tracking-[0.18em] text-parchment-200/80 font-sans">
                      {day.note}
                    </div>
                  )}
                </div>

                <div className="md:col-span-9 p-6 md:p-7">
                  <ul className="space-y-3">
                    {day.events.map((ev, i) => (
                      <li
                        key={i}
                        className="grid grid-cols-12 gap-3 md:gap-6 items-baseline border-b border-parchment-300 last:border-0 pb-3 last:pb-0"
                      >
                        <span className="col-span-3 md:col-span-2 font-serif text-lg text-terracotta">
                          {ev.t}
                        </span>
                        <span className="col-span-9 md:col-span-4 font-sans text-cocoa-900 text-sm uppercase tracking-[0.12em]">
                          {ev.e}
                        </span>
                        <span className="col-span-12 md:col-span-6 font-sans text-cocoa-700 italic text-sm">
                          {ev.v}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))
          )}
        </div>

        <p className="mt-10 text-center font-sans text-sm text-cocoa-700 italic max-w-2xl mx-auto">
          ✦ Schedules subject to change. Kindly confirm with the parish office for the most current
          information. Updated {todayIso()}.
        </p>
      </div>
    </section>
  );
}
